package com.iptvplayer.shared.presentation.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.iptvplayer.shared.domain.repository.FavoriteRepository
import com.iptvplayer.shared.presentation.state.FavoritesUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class FavoritesViewModel(
    private val favoriteRepository: FavoriteRepository
) : ViewModel() {

    private val _state = MutableStateFlow(FavoritesUiState())
    val state: StateFlow<FavoritesUiState> = _state.asStateFlow()

    init {
        loadFavorites()
    }

    private fun loadFavorites() {
        viewModelScope.launch {
            _state.update { it.copy(isLoading = true) }
            favoriteRepository.getFavorites().collect { favorites ->
                _state.update { it.copy(favorites = favorites, isLoading = false) }
            }
        }
    }

    fun removeFavorite(contentId: String) {
        viewModelScope.launch {
            favoriteRepository.removeFavorite(contentId)
        }
    }

    fun syncFavorites() {
        viewModelScope.launch {
            favoriteRepository.syncFavorites()
        }
    }
}
